// extracted by mini-css-extract-plugin
export var fadeInAnimation = "image-module--fadeInAnimation--60b81";
export var figcaption = "image-module--figcaption--d9e83";
export var figure = "image-module--figure--2252e";
export var icon = "image-module--icon--79702";
export var iconWrapper = "image-module--iconWrapper--0947c";
export var picture = "image-module--picture--77c20";
export var pictureWrapper = "image-module--pictureWrapper--f8b52";
export var wrapper = "image-module--wrapper--b6049";